// Demo-data banner. Renders a yellow notice at the top of the
// ConsumerShell when the signed-in user is the e2e-test seed account or
// when the app is running in development mode. Closes the round-3
// finding from Mei + Ahmed: "the brand-new account already has 7
// medicines and 4 safety flags — is that example data, leftover test
// data, or a leak?"
//
// In production with real users this banner stays hidden.

import { env } from '../env';
import { useDemoMode } from '../hooks/useDemoMode';
import { useMe } from '../hooks/useMe';

const E2E_EMAIL_PATTERNS = [/^e2e-test@/i, /^demo@/i, /^test@/i];

export function DemoDataBanner(): JSX.Element | null {
  const { me } = useMe();
  const demoMode = useDemoMode();
  if (demoMode) return null;
  if (!me?.email) return null;
  const isE2EUser = E2E_EMAIL_PATTERNS.some((re) => re.test(me.email));
  const isDevEnv = env.appEnv === 'development';
  if (!isE2EUser && !isDevEnv) return null;
  return (
    <output
      style={{
        display: 'block',
        padding: '8px 16px',
        background: '#fef3c7',
        color: '#78350f',
        fontSize: 14,
        fontWeight: 600,
        textAlign: 'center',
        borderBottom: '1px solid #fbbf24',
      }}
    >
      Example data shown. Your real list will replace this when you add your first medicine.
    </output>
  );
}
